import { createClient } from '@supabase/supabase-js'
const supabaseInstanceId = process.env.REACT_APP_SUPABASE_INSTANCE_ID
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export function getInstanceHostname(instanceId: string) {
  return `${instanceId}.supabase.co`
}

const createSupabaseClient = () => {
  if (!supabaseInstanceId)
    throw new Error(
      'Environment variables REACT_APP_SUPABASE_INSTANCE_ID undefined'
    )
  if (!supabaseAnonKey)
    throw new Error(
      'Environment variables REACT_APP_SUPABASE_ANON_KEY undefined'
    )
  const supabaseUrl = `https://${getInstanceHostname(supabaseInstanceId)}`
  return createClient(supabaseUrl, supabaseAnonKey)
}

export async function updateSupabaseAuth(
  token?: string,
  refreshToken?: string
) {
  if (token == null) {
    try {
      await supabaseClient.auth.signOut()
      supabaseClient.realtime.setAuth(null)
    } catch (error) {
      supabaseClient['rest'].headers['Authorization']
      supabaseClient['realtime'].setAuth(null)
    }
    return
  }

  const {
    data: { session }
  } = await supabaseClient.auth.getSession()

  const nextRefreshToken = refreshToken ?? session?.refresh_token
  if (nextRefreshToken == null) {
    throw new Error('Missing refresh token for Supabase session update')
  }

  const { error } = await supabaseClient.auth.setSession({
    access_token: token,
    refresh_token: nextRefreshToken
  })

  if (error) {
    throw error
  }

  supabaseClient.realtime.setAuth(token)
}

export const supabaseClient = createSupabaseClient()
